import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import resetPasswordConstants from '../constants/reset-password-constants';
import constants from '../../../../common/constants';
import messageBoxConstants from '../../../shared/error-message/constants/message-box-constatns';
import { validate } from '../validators/reset-password-validators';
import DefaultInput from '../../../shared/default-input/components/default-input';
import Button from '../../../shared/button/components/button';
import RenderIf from '../../../shared/render-if/components/render-if';
import MessageBox from '../../../shared/error-message/components/message-box';
import { handleErrorResetPassword } from '../actions/reset-password-actions';

class ResetPasswordForm extends Component {
  clearErrors() {
    const { errorResetPassword, handleErrorResetPassword } = this.props;

    if (errorResetPassword) {
      handleErrorResetPassword(null);
    }
  }

  render() {
    const { handleSubmit, httpInProgress, btnText, handleFormSubmit, isChangePasswordForm, errorResetPassword } = this.props;

    return (
      <form onSubmit={handleSubmit(values => handleFormSubmit(values))} noValidate className="login-container__wrapper__main__form">
        <div className="row">
          <RenderIf if={isChangePasswordForm}>
            <div className="col-md-12 m-b-20">
              <Field
                name={resetPasswordConstants.fields.old_password}
                label={'CHANGE_PASSWORD.OLD_PASSWORD'}
                disabled={httpInProgress}
                component={DefaultInput}
                onChange={() => this.clearErrors()}
                type={constants.input_types.password}
              />
            </div>
          </RenderIf>
          <div className="col-md-12 m-b-20">
            <Field
              name={resetPasswordConstants.fields.password}
              label={'LOGIN.PASSWORD_LABEL'}
              disabled={httpInProgress}
              component={DefaultInput}
              onChange={() => this.clearErrors()}
              type={constants.input_types.password}
            />
          </div>
          <div className="col-md-12">
            <Field
              name={resetPasswordConstants.fields.confirm_password}
              label={'REGISTER.CONFIRM_PASSWORD'}
              disabled={httpInProgress}
              component={DefaultInput}
              onChange={() => this.clearErrors()}
              type={constants.input_types.password}
            />
          </div>
        </div>
        <div className="row m-t-20">
          <div className="col-md-12">
            <MessageBox message={errorResetPassword} type={messageBoxConstants.message_types.error} />
          </div>
        </div>
        <Button label={btnText} customClass={'affiliate-btn-red m-t-20'} disabled={httpInProgress} type={'submit'} />
      </form>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  errorResetPassword: state.resetPasswordReducer.errorResetPassword,
});

const mapDispatchToProps = dispatch => ({
  handleErrorResetPassword: error => {
    dispatch(handleErrorResetPassword(error));
  },
});

ResetPasswordForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

ResetPasswordForm = reduxForm({
  form: resetPasswordConstants.form_name,
  validate,
})(ResetPasswordForm);

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/app/main/reset-password/components/reset-password-form.js